export function darkenHexColorWithAlpha(hex: string, percent: number): string {
  // Ensure the hex color is in the correct format
  if (hex.startsWith('#')) {
    hex = hex.slice(1)
  }

  // Convert 4-digit hex to 8-digit hex (e.g., #RGBA to #RRGGBBAA)
  if (hex.length === 4) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('')
  }

  // Convert 3-digit hex to 6-digit hex (e.g., #RGB to #RRGGBB)
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('')
  }

  // Default alpha to 255 (fully opaque) if not provided
  if (hex.length === 6) {
    hex += 'ff'
  }

  // Parse the hex color into RGBA components
  const num = parseInt(hex, 16)
  let r = (num >> 24) & 255
  let g = (num >> 16) & 255
  let b = (num >> 8) & 255
  const a = num & 255

  // Calculate the darkened color
  r = Math.max(0, Math.min(255, Math.floor(r * (1 - percent / 100))))
  g = Math.max(0, Math.min(255, Math.floor(g * (1 - percent / 100))))
  b = Math.max(0, Math.min(255, Math.floor(b * (1 - percent / 100))))

  // Convert the RGBA components back to a hex string
  const darkenedHex = ((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
  const alphaHex = a.toString(16).padStart(2, '0')

  return `#${darkenedHex}${alphaHex}`
}
